const getters = {
  getUserSessionId: (state) => state.user.sessionId,
  getAccountById: (state) => (accountId) => {
    return state.customer.accounts.find(({ id }) => id === accountId);
  },

  isVkWidget: (state) => state.isVkWidget,

  isVkMobileWidget: (state) => state.isVkMobileWidget,
  
  frontType: (state) => {
    let type = state.isVkWidget ? 'WidgetVk' : 'Widget'
    type = state.isVkMobileWidget ? 'MobileWidgetVk' : type;
    return type;
  },


  maxAvailableDiscountToAccount: (state, getters) => (accountId) => {
    const account = getters.getAccountById(accountId);

    console.log(account, accountId, 'test');

    const maxBalance = Math.floor(account.balance);

    let maxBar = state.cart.barSum - 1;
    if (maxBar < 0) {
      maxBar = 0;
    }

    let maxTickets = state.cart.ticketSum - 1;
    if (maxTickets < 0) {
      maxTickets = 0;
    }

    getters.selectedCustomerAccounts.forEach((account) => {
      if (account.id !== accountId) {
        maxBar -= account.bar;
        maxTickets -= account.tickets;
      }
    });

    let all = maxTickets + maxBar;
    let bar;

    if (all > maxBalance) {
      all = maxBalance;
    }

    let tickets = Math.ceil(all / 2);

    if (tickets >= maxTickets) {
      tickets = maxTickets;
    }

    bar = all - tickets;

    if (bar > maxBar) {
      let diff = bar - maxBar;
      tickets += diff;
      bar = maxBar;
    }

    return {
      bar,
      tickets,
      all,
    };
  },

  selectedCustomerAccounts(state) {
    let accounts = [];
    state.customer.accountsList.forEach((accountId) => {
      const account = state.customer.accounts[accountId];
      if (account.selected) {
        accounts.push(account);
      }
    });

    return accounts;
  },

  notifications: (state) => (linkName) => {
    const allNotifications = JSON.parse(
      JSON.stringify(state.data.notifications),
    );

    const routesNotificationInApi = [
      { api: 'SessionPage', name: 'home' },
      { api: 'BarPage', name: 'barGroup' },
      { api: 'PaymentPage', name: 'buy' },
    ];
    // const is3Dim = dim.includes('3D');

    const nameCurrentPageInApi = routesNotificationInApi.find(
      (page) => page.name === linkName,
    ).api;

    // notification.SeanceFormat === 'ALL' ||
    // notification.SeanceFormat === 'TWO_DIM' ||
    // notification.SeanceFormat === 'THREE_DIM',

    const filteredNotifications = allNotifications.filter((notification) =>
      notification.Placements.includes(nameCurrentPageInApi),
    );

    return filteredNotifications.sort((notification1, notification2) =>
      notification1.UpdatedAt > notification2.UpdatedAt ? -1 : 1,
    )[0];
    // .filter((notification) => !notification.OnlyThreeDim || is3Dim)[0];
  },

  // Получение бонусного аккаунта для начисления бонусов на случай, если покупка проходит без списани бонусов
  // P.S. надеюсь отработает без ошибок. из-за обращения к systemType может...
  bonusCustomerAccount(state) {
    let accounts = [];
    state.customer.accountsList.forEach((accountId) => {
      const account = state.customer.accounts[accountId];

      if (account.type.systemType === 'Bonuses') {
        accounts.push(account);
      }
    });
    return accounts;
  },

  usedDiscounts(state) {
    let tickets = 0;
    let bar = 0;

    state.customer.accountsList.forEach((accountId) => {
      const account = state.customer.accounts[accountId];
      if (account.selected) {
        tickets += account.tickets;
        bar += account.bar;
      }
    });

    return {
      tickets,
      bar,
      all: tickets + bar,
    };
  },

  total(state, getters) {
    let bar = state.cart.barSum;
    let tickets = state.cart.ticketSum;

    console.log(tickets, 'tickets');

    let discount = { bar: 0, tickets: 0, all: 0 };

    getters.selectedCustomerAccounts.forEach((account) => {
      bar -= account.discount.bar;
      tickets -= account.discount.tickets;
      discount.bar += account.discount.bar;
      discount.tickets += account.discount.tickets;
    });

    discount.all = discount.bar + discount.tickets;

    return {
      discount,
      bar,
      tickets,
      all: bar + tickets,
    };
  },
};

export default getters;
